import axios from "axios"

export const subscribeToFlightByEmail = (flightId, email, travelType, isMobileRegistration) =>
  axios.post(`/api/FormApi/SubscribeToFlightByMail`, { flightId, email, travelType, isMobileRegistration })
export const subscribeToFlightBySms = (flightId, phoneNumber, travelType, isMobileRegistration) =>
  axios.post(`/api/FormApi/SubscribeToFlightBySms`, { flightId, phoneNumber, travelType, isMobileRegistration })
export const subscribeToFlightByApp = (flightId, travelType, isMobileRegistration) =>
  axios.post(`/api/FormApi/SubscribeToFlightByApp`, { flightId, travelType, isMobileRegistration })
export const subscribeToFlight = (
  flightId,
  email,
  phoneNumber,
  appRegistration,
  travelType,
  isMobileRegistration,
  language,
  newsletterSubscription,
  registrationSource,
  permissionVersion,
) =>
  axios.post(`/api/FormApi/SubscribeToFlight`, {
    flightId,
    email,
    phoneNumber,
    appRegistration,
    travelType,
    isMobileRegistration,
    language,
    newsletterSubscription,
    registrationSource,
    permissionVersion,
  })
export const getFlights = (data) =>
  axios.post(
    `/api/GeneralSearch/SearchFlights?contentLink=${data.contentLink}&query=${data.query}*&date=${data.date}&time=${data.time}&language=${data.language}`,
  )
export const subscribeToTravelGuide = (data) => axios.post(`/api/FormApi/SubscribeToTravelGuide`, data)
export const getAirports = (data) => axios.get(`/api/Airport/Search?query=${data.query}&language=${data.language}&numberOfResults=${data.limit}`)
export const getMerchantsTypeahead = (data) => axios.get(`/api/generalsearch/searchmerchant?language=${data.language}&query=${data.query}`)
export const merchantContact = (merchantId, subject, message, senderName, senderEmail, language) =>
  axios.post(
    `/api/FormApi/MerchantContact?merchantId=${merchantId}&subject=${subject}&message=${message}&senderName=${senderName}&senderEmail=${senderEmail}&language=${language}`,
  )
export const getRejseplanenDepartureBoard = (data) =>
  axios.get(`/api/RejseplanenApi/DepartureBoard?id=${data.id}&dt=${data.datetime}&tripOptions=${data.tripOptions}`)
export const getRejseplanenTrip = (data) =>
  axios.get(`/api/RejseplanenApi/CalculateTrip?id=${data.id}&destId=${data.destId}&dt=${data.datetime}&tripOptions=${data.tripOptions}`)
export const getArticlesTypeahead = (data) => axios.get(`/api/generalsearch/searcharticles?language=${data.language}&query=${data.query}`)
export const getMerchantCarouselItems = (data) =>
  axios.get(
    `/api/Merchant/GetMerchantCarouselItemsFromCategories?categoryIds=${data.categoryIds}&language=${data.language}&useActive=${data.useActive}&estimatedPublicTime=${data.estimatedPublicTime}`,
  )
export const getFlightInfoTable = (data) =>
  axios.get(
    `/api/FlightInformation/GetFlightInfoTable?direction=${data.direction}&userQuery=${data.query}&startDateTime=${data.startDateTime}&endDateTime=${data.endDateTime}&language=${data.language}`,
  )
export const getAirportsFromFlights = (data) =>
  axios.get(`/api/FlightInformation/GetAirports?direction=${data.direction}&userQuery=${data.query}&language=${data.language}`)
export const getParkingContent = (data) => axios.get(`/api/parking/getparkingcontent?language=${data.language}&camelCase=${data.camelCase}`)
export const getParkingConfig = (data) => axios.get(`/api/parking/getparkingconfiguration?language=${data.language}&camelCase=${data.camelCase}`)
export const getAirlines = (data) => axios.get(`/api/FlightInformation/GetAirlinesList?userQuery=${data.query}&language=${data.language}`)
export const getAirlinesFromHandlingCompany = (data) =>
  axios.get(`/api/FlightInformation/GetAirlinesFromHandlingCompany?handlingCompany=${data.handlingCompany}&language=${data.language}`)
export const getMerchantCategory = (data) => axios.get(`/api/Merchant/GetCategory?categoryId=${data.categoryId}&language=${data.language}`)
export const getMerchantCategoryList = (data) => axios.get(`/api/Merchant/GetCategoryList?categoryIds=${data.categoryIds}&language=${data.language}`)
export const getFlightLink = (data) => axios.get(`/api/FlightInformation/GetFlightLink?flightId=${data.flightId}&language=${data.language}`)
export const verifyReCaptcha = (data) => axios.post(`/api/FormApi/VerifyReCaptcha`, data)
